<template>
    <div class="col-12">
        <span class="span-title">{{ $t('orders.allocated_vehicles') }}</span>
        <div v-if="selectedVehicles.length < 1" class="col-sm-12" style="font-style: italic">
            <span>{{ $t('contracts.no_order_vehicles') }}</span>
        </div>
        <div class="col-sm-12 pt-1">
            <multiselect
                v-model="selectedVehicles"
                @input="vehiclesChanged"
                class="multiselect_routa"
                :placeholder="$t('ins_wizard.select_vehicle')"
                :deselect-label="$t('common.remove_selection')"
                :select-label="$t('common.select')"
                :close-on-select="false"
                :multiple="true"
                open-direction="bottom"
                label="make"
                track-by="id"
                :custom-label="customLabel"
                :searchable="true"
                :internal-search="true"
                :clear-on-select="false"
                :selected-label="$t('common.selected')"
                :options="vehicles"
            >
                <template
                    slot="singleLabel"
                    slot-scope="props"
                >
              <span class="option__desc">
                <span class="option__title">{{ props.option.license_plate + ' ' + props.option.make + ' - ' + props.option.vehicle_model }}</span>
              </span>
                </template>
                <template
                    slot="option"
                    slot-scope="props"
                >
                    <div class="option__desc">
                        <span class="option__title multiselect_detail_block">{{ props.option.license_plate + ' ' + props.option.make + ' - ' + props.option.vehicle_model }}</span>
                    </div>
                </template>
                <span slot="noResult">{{ $t('common.not_found') }}</span>
                <span slot="noOptions">{{ $t('common.no_results') }}</span>
            </multiselect>
        </div>
        <span class="hint-text mt-2">{{ $t('orders.vehicle_allocation_hint') }}</span>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from "../mixins/TimeUtils";

export default {
    name: 'OrderVehicleAllocation',
    mixins: [restApi, timeUtils],
    props: {
        modelValue: {
            type: Array,
            default: function () {
                return []
            }
        },
        order: {
            type: Object,
            default: null
        },
    },
    data: function () {
        return {
            loading: false,
            vehicles: [],
            selectedVehicles: this.modelValue ? this.modelValue : []
        }
    },
    watch: {
        selectedVehicles: function () {
            this.$emit('update:modelValue', this.selectedVehicles)
        }
    },
    mounted: function () {
        this.selectedVehicles = this.modelValue ? this.modelValue : []
        this.fetchVehicles()
    },
    methods: {
        fetchVehicles: function () {
            this.loading = true
            this.vehicles = []
            this.restFetchParams(this.vehicleUrl,
                {
                    in_use: 1
                },
                this.handleVehicles)
        },
        handleVehicles: function (results) {
            this.loading = false
            if (results.data) {
                this.vehicles = results.data
            }
        },
        vehiclesChanged() {
            this.$emit('vehiclesChanged')
        },
        isSelected: function (id) {
            return this.selectedVehicles.find(item => item.id === id) !== undefined
        },
        customLabel(option) {
            // This controls how the options are displayed
            return `${option.license_plate} ${option.make} - ${option.vehicle_model}`;
        },
    }

}
</script>
